<template lang="html">
  <div>
    <input-wrapper
    :error="error"
    :sneaky="true"
    :helperText="helperText"
    :disabled="disabled"
    :class="Object.assign({'checkbox' : 1}, classList)">

      <div v-bind:class="{'with-link': link}">
        <label :class="classList" :for="id">        
          <input
          :id="id"
          type="checkbox"
          :disabled="disabled"
          v-model="currentValue" />

          <svg class="icon" viewBox="0 0 16 16">
            <use-svg class="background" name="checkbox" stroke-width="2" :fill-opacity="fillOpacity" :class="{disabled: disabled}"/>

            <g>
              <path
              ref="tick"
              fill="none"
              class="tick"
              stroke-width="2"
              stroke-linecap="round"
              :stroke-dasharray="tickLength + ' ' + tickLength"
              :stroke-dashoffset="tickDashOffset"
              :stroke-opacity="tickOpacity"
              d="M 5,9 7,11 11,6" />
            </g>

          </svg>

          <div v-if="!link">
            {{label}}
          </div>

          <div class="asterisk" v-if="isRequired">
            *
          </div>
        </label>

        <div @click="openNewTab(link)" v-if="link">
          {{label}}
        </div>

      </div>
    </input-wrapper>
  </div>
</template>

<script>
  import input from '../../../mixins/input'
  import InputWrapper from '../../../components/ui/inputs/InputWrapper'
  import InputLabel from '../../../components/ui/inputs/InputLabel.vue'
  import Icon from '../../../components/ui/Icon.vue'
  import InputFooter from '../../../components/ui/inputs/InputFooter'
  import UseSvg from '../../../components/ui/UseSvg.vue'
  import TWEEN from '@tweenjs/tween.js'

  export default {
    name: 'Checkbox',

    mixins: [input],

    components: {
      UseSvg,
      InputFooter,
      InputWrapper,
      InputLabel
    },

    props: {
      value: {
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      },

      label: String,

      link: String,

      isRequired: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        fillOpacity: 0.0,
        tickDashOffset: 0,
        tickLength: 0,
        tickOpacity: 1.0
      }
    },

    computed: {
      desiredOpacity: () => this.hasValue ? 1.0 : 0.0,
    },

    watch: {
      hasValue(checked) {
        let animate = () => {
          if (TWEEN.update()) {
            requestAnimationFrame(animate)
          }
        }

        if(checked) {
          this.tickOpacity = 1.0

          this.stateAnimation({tickOpacity: 1.0, tickDashOffset: this.tickLength, fillOpacity: this.fillOpacity})
            .to({tickDashOffset: this.tickLength, fillOpacity: 0.5}, 200, TWEEN.Easing.Quadratic.In)
            .to({tickDashOffset: 0.0, fillOpacity: 1.0}, 300, TWEEN.Easing.Quadratic.InOut)
            .start()
        } else {
          this.stateAnimation({tickOpacity: this.tickOpacity, fillOpacity: this.fillOpacity})
            .to({tickOpacity: 0.0, fillOpacity: 0.0}, 300, TWEEN.Easing.Quadratic.Out)
            .start()
        }

        animate()
      }
    },

    methods: {
      openNewTab(link) {
        window.open(link, "_blank")
      },
      stateAnimation(initial) {
        return new TWEEN.Tween(initial)
          .onUpdate((tweened) => {
            this.tickDashOffset = tweened.tickDashOffset
            this.fillOpacity = tweened.fillOpacity
            this.tickOpacity = tweened.tickOpacity
          })
      }
    },

    mounted() {
      this.tickLength = this.$refs.tick.getTotalLength()

      if(this.hasValue) {
        this.tickDashOffset = 0.0
        this.fillOpacity = 1.0
        this.tickOpacity = 1.0
      } else {
        this.tickDashOffset = this.tickLength
        this.fillOpacity = 0.0
        this.tickOpacity = 0.0
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  .checkbox
    label, .with-link
      cursor: pointer
      display: flex
      align-items: center

    input[type="checkbox"]
      display: none

    .icon
      width: 20px
      height: 20px
      border-radius: 3px
      margin-right: 10px

    .background
      transition: stroke $transition-duration $transition-easing
      fill: $color-primary
      stroke: $color-border-lighter
      stroke-width: 3

    &.has-value
      .background
        stroke: $color-input-border-active

    .tick
      transition: stroke $transition-duration $transition-easing
      stroke: $color-primary

    &.is-invalid
      + .input-footer
        .validation-error
          color: $color-error

      .tick
        stroke: $color-error

      .background
        fill: $color-error
        stroke: $color-error

    &.has-value
      .tick
        stroke: white

    &.disabled
      .background
        fill: $color-grey-lighter
        stroke: $color-grey-lighter
        fill-opacity: 1

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/Checkbox.vue